const USERS_DATA = 'users-data';

export interface UserData {
  bookmarks?: Bemob.Bookmark[];
  desktopViewForced?: boolean,
  selectedWorkspaces?: string[],
}

const saveUserDataToLocalStorage = ( id, data:UserData) =>{
  if(!id) return;
  const allUsers = JSON.parse(window.localStorage.getItem(USERS_DATA)) || {}
  window.localStorage.setItem(USERS_DATA,JSON.stringify({
    ...allUsers,
    [id]:{
      ...allUsers[id] || {},
      ...data
    }
  }))
}

const getUserDataFromLocalStorage = (id) =>{
  const allUsers = JSON.parse(window.localStorage.getItem(USERS_DATA)) || {}
  return allUsers[id] || {}
}

export {saveUserDataToLocalStorage,getUserDataFromLocalStorage}